import styled from 'styled-components';

const defaultComponent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  text-align: left;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0px 0.25rem 0.5rem 0px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
`;

const buttonBox = styled.a`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #115c5b;
  cursor: pointer;
`;

const titleBox = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 1rem;
  padding-left: 15px;
  padding-right: 15px;
  line-height: 20px;
  color: #115c5b;
  width: 100%;
  display: block;
`;

const defaultBox = styled.div`
  width: 100%;
  max-width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  margin-bottom: 10px;
`;

const defaultDivider = styled.div`
  border-bottom: 1px solid #414042;
  display: block;
  margin: 0 auto 2rem;
  width: calc(100% - 30px);
`;

const Filter = {
  Default: defaultComponent,
  Box: defaultBox,
  Divisor: defaultDivider,
  Title: titleBox,
  divider: defaultBox,
  Button: buttonBox,
};

export default Filter;
